import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/routes.jsx';
import './styles/tokens.css';
import './styles/global.css';

/**
 * SportsSpots v3 - React Entry Point
 * 
 * Initializes the React application with:
 * - RouterProvider for navigation
 * - Design tokens and global styles
 * - Root element mounting
 */

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
